import {
    DialogBody, DialogCloseTrigger,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle
} from "../../components/ui/dialog";
import {Button, DialogContext, Input} from "@chakra-ui/react";
import styled from "styled-components";
import {Field} from "../../components/ui/field";
import {PasswordInput} from "../../components/ui/password-input";
import {useState} from "react";
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import {firebaseApp} from "../../firebase/firebase";
import {toaster} from "../../components/ui/toaster";
import {createUserDocument} from "../../firebase/firestore";

const Header = styled(DialogHeader)`
  text-align: center;
  margin: 24px 0;
`;
const Footer = styled(DialogFooter)`
  margin: 24px 0;
  display: flex;
  align-self: center;
  justify-content: space-around;
  width: 100%;
`;
const Title = styled(DialogTitle)`
  font-size: 24px;
`;
const Body = styled(DialogBody)`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;
const StyledButton = styled(Button)`
  width: 100%;
  font-size: 18px;
  padding: 24px;
`;

const auth = getAuth(firebaseApp);

function RegisterDialog() {
    const [email, setEmail] = useState();
    const [emailError, setEmailError] = useState(false);
    const [password, setPassword] = useState();
    const [pending, setPending] = useState(false);

    const handleChange = (e) => {
        const value = e.target.value;
        setEmail(value);
        // Prosty regex do walidacji emaila
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (value && !emailRegex.test(value)) {
            setEmailError(true);
        } else {
            setEmailError(false);
        }
    };
    const onUserRegister = async (dialogStore) => {
        if (password?.length < 8 || emailError) {
            return;
        }

        setPending(true);
        await createUserWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                const user = userCredential.user;
                toaster.create({
                    title: 'Konto zostało stworzone! Jesteś zalogowany',
                    type: 'success',
                })
                setEmail(undefined)
                setPassword(undefined);
                dialogStore.setOpen(false)
                createUserDocument(user);
            })
            .catch((error) => {
                let errorMsg = 'Nie udało się zarejestrować użytkownika. Skontaktuj się z administratorem lub spróbuj ponownie później';
                if (error?.code === 'auth/email-already-in-use') {
                    errorMsg = 'Konto z podanym adresem email już istnieje'
                }

                toaster.create({
                    title: errorMsg,
                    type: 'error',
                })
            })
            .finally(() => {
                setPending(false);
            })
    }

    return <DialogContent>
        <Header>
            <Title>STWÓRZ KONTO</Title>
        </Header>
        <Body>
            <Field
                label="Adres email"
                invalid={emailError}
                errorText="Niepoprawny format email"
            >
                <Input
                    value={email}
                    variant="flushed"
                    type="email"
                    onChange={handleChange}
                    placeholder="Podaj poprawny adres email"
                />
            </Field>
            <Field
                label="Hasło"
                invalid={password && password?.length < 8}
                errorText="Przynajmniej 8 znaków"
            >
                <PasswordInput
                    value={password}
                    variant="flushed"
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Podaj przynamjniej 8 znaków"
                />
            </Field>
        </Body>
        <Footer>
            <DialogContext>
                {(store) => (
                    <StyledButton
                        loading={pending}
                        disabled={password?.length < 8 || !email || emailError}
                        onClick={() => onUserRegister(store)}
                    >
                        Rejestracja
                    </StyledButton>
                )}
            </DialogContext>
        </Footer>
        <DialogCloseTrigger />
    </DialogContent>
}

export default RegisterDialog;
